<template>
  <div id="home-photo" class="half-scherm p-0 overflow-hidden">
    <div class="overlay h-100 w-100">
      <div class="filter h-100 m-0"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'photo',
};
</script>
